import React, { useMemo, useState } from "react";
import {
    Box,
    Text,
    Card,
    Flex,
    useColorModeValue,
    Accordion,
} from "@chakra-ui/react";
import { useTimerTracker } from "../hooks/useTimeTracker";
import Pagination from "rc-pagination";
import TimerRow from "./TimerRow";

type TimerTableProps = Pick<useTimerTracker.type, 'state' | 'deleteTimerExec'>;

const TimerTable: React.FC<TimerTableProps> = ({ state, deleteTimerExec }) => {

    const textColor = useColorModeValue("navy.700", "white");

    const countPerPage = 10
    const [currentPage, setCurrentPage] = useState(1);

    const groupedTimers = useMemo(() => {
        return state.timerList.reduce((acc, timer) => {
            const dateKey = new Date(timer.finalMoment).toISOString().split("T")[0];

            // @ts-ignore
            if (!acc[dateKey]) {
                // @ts-ignore
                acc[dateKey] = [];
            }
            // @ts-ignore
            acc[dateKey].push(timer);

            return acc;
        }, {});
    }, [state.timerList]);

    const dateKeys = useMemo(() => Object.keys(groupedTimers), [groupedTimers]);

    const paginatedGroups = useMemo(() => {
        const from = (currentPage - 1) * countPerPage;
        const to = from + countPerPage;
        return dateKeys.slice(from, to).reduce((acc, date) => {
            // @ts-ignore
            acc[date] = groupedTimers[date];
            return acc;
        }, {});
    }, [dateKeys, currentPage]);

    const updatePage = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <Card flexDirection="column" px="25px" overflowX={{ sm: "scroll", lg: "hidden" }}>
            <Flex
                mb="16px"
                mt="16px"
                justifyContent="space-between"
                align="center"
            >
                <Text
                    color={textColor}
                    fontSize="22px"
                    fontWeight="700"
                    lineHeight="100%"
                >
                    Listagem de Timers
                </Text>
                {/* <Button colorScheme="brand" variant="outline">
                    Adicionar
                </Button> */}
            </Flex>
            <Box>

                {/* <Stack p={4}>
                    <FormControl>
                        <FormLabel
                            display="flex"
                            ms="4px"
                            fontSize="sm"
                            fontWeight="bold"
                            color={textColor}
                            mb="8px"

                        >
                            Buscar
                        </FormLabel>

                        <Input
                            fontSize="sm"
                            ms={{ base: "0px", md: "0px" }}
                            type="text"
                            placeholder="Buscar"
                            fontWeight="500"
                            w={320}
                            size="md"
                            onChange={e => setValue(e.target.value)}
                            value={value}
                        />
                    </FormControl>
                </Stack> */}

                <Accordion allowMultiple>
                    {Object.entries(paginatedGroups).map(([date, timers]) => (
                        <TimerRow
                            key={date}
                            date={date}
                            timers={timers as any}
                            deleteHandler={deleteTimerExec}
                        />
                    ))}
                </Accordion>

                <Pagination
                    pageSize={countPerPage}
                    onChange={updatePage}
                    current={currentPage}
                    total={state.timerList.length}
                    style={{
                        float: 'right',
                        marginRight: 24,
                        marginBottom: 24,
                        marginTop: 24
                    }}
                />
            </Box>
        </Card>
    );
}

export default TimerTable;